export default class TypSubdodavkyService{

  constructor(server){
    this.server = server;
  }

  list(){
    return this.server("TypSubdodavky.list").then(r => r.result);
  }

  save(item){
    return this.server("TypSubdodavky.create", item);
  }

  update(item){
    return this.server("TypSubdodavky.update", item); 
  }

  remove(item){
    return this.server("TypSubdodavky.delete", {id: item.id});
  }


}


// WEBPACK FOOTER //
// ./src/services/TypSubdodavkyService.js